export default __webpack_public_path__ + "static/media/open-link-dark.9fa0cf6a.svg";